/**
 * embed.ts — modo EMBED de atividade única (F3 dos jogos, P-166).
 *
 * Quando uma página do Ensino Social abre UMA atividade dentro de iframe
 * (🧮 Atividade do dia do Bit, /encceja/praticar, bloco "praticar" da aula),
 * ela monta a URL com ?embed=1. O modo:
 *   - esconde o "← Voltar" e troca sair-pro-hub por ponte.sair() — o PAI
 *     decide o que fazer (fechar, voltar pra salinha, trocar de aba);
 *   - liga ponte.autoResize() — o iframe cresce com o conteúdo e nada
 *     fica cortado nem com rolagem interna;
 *   - compacta o layout (body.is-embed no CSS) — o viewport é pequeno.
 *
 * NÃO é auto-detectado por window.parent de propósito: o hub inteiro também
 * roda em iframe (/jogos do monólito) e lá a navegação interna É o produto.
 * Embed é opt-in de quem embeda uma atividade só.
 */
export const isEmbed: boolean = (() => {
  try {
    return new URLSearchParams(window.location.search).get('embed') === '1';
  } catch {
    return false;
  }
})();
